import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { TenantThemeProvider } from './components/TenantThemeProvider'
import { installChunkLoadRecovery } from './utils/lazyWithReload'
import { applyQuickFontAdjustment, getQuickFontAdjustment } from './utils/quickFontSize'
import '@agentic360/diagram-renderer/styles'
import './index.css'

const rootEl = document.getElementById('root')!

// Public radar embed: a bare, unauthenticated surface rendered inside external
// customer iframes (/embed/radar/{public_id}). It must never boot the OIDC auth
// flow, the service worker, or the admin chrome — so branch before any of that.
if (window.location.pathname.startsWith('/embed/')) {
  import('./embed/RadarEmbedApp').then(({ default: RadarEmbedApp }) => {
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        {/* Locale JSONs load async now (see src/i18n); useTranslation suspends
            until the active language arrives, so a boundary must sit above every
            translated component. */}
        <React.Suspense fallback={null}>
          <RadarEmbedApp />
        </React.Suspense>
      </React.StrictMode>,
    )
  })
} else {
  installChunkLoadRecovery()
  applyQuickFontAdjustment(getQuickFontAdjustment())

  // Keep the admin shell loadable across short backend outages. The SW caches
  // Vite chunks + fonts and bypasses /api/, /ws, /silent-renew, /oauth so it
  // never serves stale auth state. See public/sw.js.
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    })
  }

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <TenantThemeProvider>
          <App />
        </TenantThemeProvider>
      </React.Suspense>
    </React.StrictMode>,
  )
}
